import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify, {
  theme: {
    primary: '#004F27',
    secondary: '#DEC68A'
  }
})
